type Grant = {
  userId: string | null;
  builtinRoleId: string | null;
  customRoleId: string | null;
  scopeId: string;
};

type User = { id: string; deactivated: boolean | null };

export type UserWithScopes<U> = { user: U; scopeIds: string[] };

export function findUsersForRole<U extends User>(
  grants: readonly Grant[],
  roleId: string,
  isBuiltin: boolean,
  userMap: ReadonlyMap<string, U>
): UserWithScopes<U>[] {
  const byUser = new Map<
    string,
    { user: U; scopeIds: string[]; seen: Set<string> }
  >();
  for (const g of grants) {
    const matches = isBuiltin
      ? g.builtinRoleId === roleId
      : g.customRoleId === roleId;
    if (!matches || !g.userId) continue;
    let entry = byUser.get(g.userId);
    if (!entry) {
      const user = userMap.get(g.userId);
      if (!user || user.deactivated) continue;
      entry = { user, scopeIds: [], seen: new Set() };
      byUser.set(g.userId, entry);
    }
    if (entry.seen.has(g.scopeId)) continue;
    entry.seen.add(g.scopeId);
    entry.scopeIds.push(g.scopeId);
  }
  return [...byUser.values()].map(({ user, scopeIds }) => ({ user, scopeIds }));
}
